export default {
    '400': '请求参数错误',
    '401': '登录状态已过期！',
    '403': '无效Token',
    '404': '访问资源不存在',
    '405': '不允许的Http请求',
    '406': '请求超时',
    '500': '服务异常，请稍后再试！',
    'default': '系统未知错误，请反馈给管理员'
}